export enum EventsTypeEnum {
  YES = 'SIM',
  NO = 'NÃO'
}

export enum EventsTypeIdEnum {
  'SIM' = 1,
  'Não' = 2
}

export function getEventsTypeDescriptionByValue(value: number) {
  const indexOfS = Object.values(EventsTypeIdEnum).indexOf(
    value as unknown as EventsTypeIdEnum
  );

  const key = Object.keys(EventsTypeIdEnum)[indexOfS];

  return key;
}


